// Define the app and which modules to load
var eshopApp = angular.module('eshopApp', [
	'ngAnimate', 
	'ngSanitize', 
	'ngCookies', 
    'ui.bootstrap',
	'dibari.angular-ellipsis'
]);